import { IS_PROD } from 'configs'
import { useEffect } from 'react'
import { FieldErrors, FieldPath, FieldValues, UseFormReturn } from 'react-hook-form'

/**
 * Custom hook that focuses on the first error in a form.
 * @template T - The type of form values.
 * @param {UseFormReturn<T>} useFormReturn - The useForm return object from react-hook-form.
 */
const useFormErrorFocus = <T extends FieldValues>(useFormReturn: UseFormReturn<T>) => {
  const {
    formState: { errors },
    setFocus,
  } = useFormReturn

  useEffect(() => {
    const firstError = Object.keys(errors).find((field) => !!errors[field as keyof FieldErrors<T>])
    if (!firstError) return // no error
    !IS_PROD && console.log('firstError', errors[firstError])
    setFocus(firstError as FieldPath<T>)
  }, [errors, setFocus])
}

export default useFormErrorFocus
